<script>
  import { Link } from 'svelte-routing';
  import ThemeToggle from '../components/ThemeToggle.svelte';
  import { loginRedirect } from '../lib/auth.js';

  let { user = null, logout = null } = $props();

  const tiles = [
    { to: '/captures', icon: 'inbox',          title: 'Captures', sub: 'Inspect incoming webhooks' },
    { to: '/buckets',  icon: 'folder',         title: 'Buckets',  sub: 'Group captures by source' },
    { to: '/logs',     icon: 'manage_search',  title: 'Logs',     sub: 'Telebroad-integrations Winston logs' },
    { to: '/status',   icon: 'monitor_heart',  title: 'Status',   sub: 'Probe URLs, alert on outages' },
    { to: '/users',    icon: 'group',          title: 'Users',    sub: 'Manage portal access' },
    { to: '/audit',    icon: 'history',        title: 'Audit',    sub: 'Recent operator actions' },
    { to: '/settings', icon: 'settings',       title: 'Settings', sub: 'Alert dispatch + integrations' },
  ];
</script>

<div class="min-h-screen flex flex-col bg-surface text-on-surface">
  {#if user}
    <header class="h-16 px-4 md:px-6 flex items-center gap-4 bg-surface-container border-b border-outline-variant">
      <span class="material-symbols-outlined text-primary">webhook</span>
      <h1 class="text-lg font-medium tracking-wide">hook-index</h1>
      <div class="ml-auto flex items-center gap-2">
        <ThemeToggle />
        <span class="hidden sm:inline text-sm text-on-surface-variant">{user.email || user.username}</span>
        <button
          onclick={logout}
          class="px-4 py-2 rounded-full text-sm hover:bg-surface-container-high text-on-surface-variant"
          title="Sign out"
        >
          <span class="material-symbols-outlined text-base align-middle">logout</span>
          Sign out
        </button>
      </div>
    </header>
  {:else}
    <!-- Theme toggle floats top-right; sign-in lives in the hero CTA. -->
    <div class="absolute top-4 right-4">
      <ThemeToggle />
    </div>
  {/if}

  <main class="flex-1 flex flex-col items-center justify-center px-6 py-12 text-center">
    <span class="material-symbols-outlined text-primary mb-4" style="font-size: 72px;">webhook</span>
    <h2 class="text-4xl md:text-5xl font-medium tracking-tight mb-3">Welcome to hook-index</h2>
    <p class="max-w-xl text-on-surface-variant mb-8">
      Inspect and replay incoming webhooks. Group captures into buckets, audit operator activity, and manage portal access — all from one place.
    </p>

    {#if !user}
      <button
        onclick={loginRedirect}
        class="px-8 py-3 rounded-full bg-primary text-on-primary text-base font-medium hover:opacity-90"
      >
        <span class="material-symbols-outlined align-middle mr-1">login</span>
        Sign in with Telebroad
      </button>
    {:else}
      <div class="mt-2 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 xl:grid-cols-7 gap-4 w-full max-w-7xl">
        {#each tiles as t}
          <Link
            to={t.to}
            class="text-left p-5 rounded-2xl bg-surface-container hover:bg-surface-container-high transition flex flex-col gap-2"
          >
            <span class="material-symbols-outlined text-primary text-3xl">{t.icon}</span>
            <span class="text-base font-medium">{t.title}</span>
            <span class="text-xs text-on-surface-variant">{t.sub}</span>
          </Link>
        {/each}
      </div>
    {/if}
  </main>
</div>
